<div class="cat__footer">
    <div class="cat__footer__top">
        <div class="cat__pages__login__footer">
            <ul class="list-inline">
                <!-- Note: these same links exist in login.page.html -->
                <li class="list-inline-item">
                    <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/refund-policy')"
                       class="text-primary">Refund</a>
                </li>
                <li class="list-inline-item">
                    <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/privacy-policy')"
                       class="text-primary">Privacy</a>
                </li>
                <li class="list-inline-item">
                    <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/copyright')"
                       class="text-primary">Copyright</a>
                </li>
                <li class="list-inline-item">
                    <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/security')"
                       class="text-primary">Security</a>
                </li>
                <li class="list-inline-item">
                    <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/disclaimer')"
                       class="text-primary">Disclaimer</a>
                </li>
            </ul>
        </div>
    </div>
    <!-- sjaslow: I didn't like this, gets in the way of the UI.
      <a href="javascript: void(0);" class="cat__core__scroll-top" onclick="$('body, html').animate({'scrollTop': 0}, 500);"><i class="icmn-arrow-up"></i></a>
      -->
      <div class="cat__footer__bottom">
        <div class="cat__footer__description">
            For assistance, contact us by
            <a href="mailto:supportservices@lls.org?subject=Light The Night eTools Question">email</a>
             or call us at <a href="tel:888-557-7177" class="text-nowrap">888-LLS-7177</a> Monday - Friday 9:30 AM - 5:30 PM EST.
        </div>
    </div>

    <about-link></about-link>
</div>
